import { useCallback } from "react";
import { TransactionRuleGroup } from "../../../../common/types/transactionRule";
import { useUpdateRuleGroup } from "../../../../api/ruleGroups.api";
import { RuleGroupForm, RuleGroupSchema } from "./RuleGroupForm";

export const UpdateRuleGroupModal = ({
    ruleGroup,
    onHide,
}: {
    ruleGroup: TransactionRuleGroup | null;
    onHide: () => void;
}) => {
    const updateMutation = useUpdateRuleGroup(onHide);

    const onSubmit = useCallback(
        (ruleGroupData: RuleGroupSchema) => {
            if (!ruleGroup) {
                return;
            }

            return updateMutation.mutateAsync({
                workspaceId: ruleGroup.workspaceId,
                groupId: ruleGroup.id,
                ruleGroup: {
                    name: ruleGroupData.name,
                    icon: ruleGroup.icon,
                    order: ruleGroup.order,
                },
            });
        },
        [updateMutation, ruleGroup],
    );

    if (!ruleGroup) {
        return null;
    }

    return (
        <RuleGroupForm
            ruleGroup={ruleGroup}
            onHide={onHide}
            onSubmitRuleGroup={onSubmit}
            isPending={updateMutation.isPending}
            isAccounting={ruleGroup.isAccounting}
        />
    );
};
